module.exports = __webpack_public_path__ + "img/text_1.4e9bbee3.svg";